import propTypes from 'prop-types';

const Stepper = ({ children }) => {
  return (
    <>
      <div className="stepper">{children}</div>
      <style jsx>{`
        .stepper {
          padding: 15px 0;
        }
      `}</style>
    </>
  );
};

Stepper.propTypes = {
  children: propTypes.any,
};

export default Stepper;
